import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { IEvent } from '@clickersphere/core/entities/IEvent';
import EventService from '@clickersphere/core/services/EventService';
import { useBuildQueryKey } from '../useBuildQueryKey';

export const EVENTS_QUERY_KEY = 'events';

export type EventQueryData = WithQueryStatus<IEvent>;

export function useEvents() {
  const { buildQueryKey } = useBuildQueryKey();
  const {
    data: events,
    isSuccess: isEventsSuccess,
    isFetching: isEventsFetching,
    isLoading: isEventsLoading,
  } = useQuery({
    queryKey: buildQueryKey(EVENTS_QUERY_KEY),
    queryFn: async () => {
      const events = await EventService.getAll();
      return events as EventQueryData[];
    },
    staleTime: Infinity,
    select: (data) => {
      return [...data].sort((a, b) => {
        if (!a.date && !b.date) return 0;
        if (!a.date) return 1;
        if (!b.date) return -1;
        return Date.parse(b.date) - Date.parse(a.date);
      });
    },
  });

  return {
    events,
    isEventsSuccess,
    isEventsFetching,
    isEventsLoading,
  };
}
